<template>
  <div class="not-found">
    <h1>404 - 页面未找到</h1>
    <p>你访问的页面不存在。</p>
  </div>
</template>

<script lang="ts" setup></script>

<style scoped lang="less">
.not-found {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100vh;
  text-align: center;

  h1 {
    font-size: 2em;
    color: #ff6f61;
  }

  p {
    font-size: 1.2em;
    color: #333;
  }
}
</style>
